// extracted by mini-css-extract-plugin
export default {"container":"footer_container__tTpaG","text":"footer_text__9aNvQ","link":"footer_link__ylPIY","underline":"footer_underline__u8rKT"};